import { InformationSection } from '../../Profile/components/InformationSection';
import { ParticipantInputByName } from '../../Profile/components/ParticipantInputByName';
import {
  ParticipantFieldCategory,
  useParticipantFieldsCategory,
} from '@app/api';

interface Props {
  displayedFields?: string[];
}
const allFields = ['birthdate', 'gender'];

export const Demographic = ({ displayedFields = allFields }: Props) => {
  const categoryConfig = useParticipantFieldsCategory(
    ParticipantFieldCategory.DEMOGRAPHIC,
  );
  if (!categoryConfig) {
    return null;
  }
  return (
    <InformationSection
      title={categoryConfig.title}
      icon="ri-pie-chart-line"
      iconColor="blue"
      description={categoryConfig.description}
    >
      {displayedFields.includes('birthdate') && (
        <ParticipantInputByName fieldName="birthdate" />
      )}
      {displayedFields.includes('gender') && (
        <ParticipantInputByName fieldName="gender" />
      )}
    </InformationSection>
  );
};
